import { TranslatePipe } from '../i18n/translate.pipe';
import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-donner',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './donner.html',
  styleUrls: ['./donner.scss']
})
export class DonnerComponent {
  readonly iframeLoaded = signal(false);
  readonly iframeError = signal(false);
  readonly donationUrl = 'https://www.helloasso.com/associations/agbe/formulaires/14';
  readonly donationWidgetUrl = `${this.donationUrl}/widget`;
}
